import React from 'react';

import './CardIconAction.scss';

const CardIconActions = ({ children, className = '', inline = false }) => (
    <div
        className={`CardIconActions ${inline ? 'CardIconActions--inline' : ''} ${className}`.trim()}
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
        role="presentation"
    >
        {children}
    </div>
);

export default CardIconActions;
